import { useRuntimeConfig } from '#imports';
import * as Sentry from '@sentry/nuxt';

const runtimeConfig = useRuntimeConfig();
const environment = runtimeConfig.public.ENV;

Sentry.init({
  dsn: runtimeConfig.public.SENTRY_DSN,
  enabled: runtimeConfig.public.IS_HEADER_FOOTER_EXPORT && environment === 'staging', // Currently only enabled for staging shop environment
  environment,
  // Tracing: We recommend adjusting this value in production, or using a tracesSampler for finer control.
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
});
